import { Injectable } from "@angular/core";
import { Pessoa } from "@tivic-team/manager-ts/dist/grl";
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { Linha } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity";
import { Vistoria } from "@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity";
import { ConcessaoColetivoUrbanoDTO } from "app/model/dtos/mob/concessao-coletivo-urbano.dto";
import { ConcessaoColetivoRuralDTO } from "app/model/dtos/mob/concessao-coletivorural.dto";
import { ConcessaoTaxiDTO } from "app/model/dtos/mob/concessao-taxi.dto";
import { ConcessaoVeiculoDTO } from "app/model/dtos/mob/concessao-veiculo.dto";
import { ConcessaoDTO } from "app/model/dtos/mob/concessao.dto";
import { ConcessionarioPessoaDTO } from "app/model/dtos/mob/concessionario-pessoa.dto";
import { PermissaoTaxiDTO } from "app/model/dtos/mob/permissao-taxi.dto";
import { RelatorioConcessaoListDTO } from "app/model/dtos/mob/relatorio-concessao.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { environmentv3 } from "./../../../environments/environmentv3";
import { FormFile } from "app/interface/form-file";

@Injectable()
export class ConcessaoController {
  constructor() {}

  async getAll(): Promise<Array<ConcessaoDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao",
          environment: environment,
        }),
      }),
      new HttpResponse(new Array<Concessao>())
    );
    return await quark.call();
  }

  async findConcessao(filtros?: IFilter): Promise<Array<ConcessaoDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/concessao",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<ConcessaoDTO>())
    );
    return await quark.call();
  }

  async findRelatorioConcessao(
    filtros?: IFilter
  ): Promise<Array<RelatorioConcessaoListDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/relatorioconcessoes",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<ConcessaoDTO>())
    );
    return await quark.call();
  }

  //Coletivo Urbano
  async findColetivoUrbano(
    filtros?: IFilter
  ): Promise<Array<ConcessaoColetivoUrbanoDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/coletivourbano",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<ConcessaoColetivoUrbanoDTO>())
    );
    return await quark.call();
  }

  async findNomeConcessionarioColetivoUrbano(
    filtros?: IFilter
  ): Promise<Array<Pessoa>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/coletivourbano/concessionario",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<Pessoa>())
    );
    return await quark.call();
  }

  async getColetivoUrbano(
    cdConcessao: number
  ): Promise<ConcessaoColetivoUrbanoDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/coletivourbano/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new ConcessaoColetivoUrbanoDTO())
    );
    return await quark.call();
  }

  async createColetivoUrbano(
    concessaoColetivoUrbanoDTO: ConcessaoColetivoUrbanoDTO
  ): Promise<ConcessaoColetivoUrbanoDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: "mob/concessao/coletivourbano",
          environment: environment,
        }),
        data: new JSONData(concessaoColetivoUrbanoDTO),
      }),
      new HttpResponse(new ConcessaoColetivoUrbanoDTO())
    );
    return await quark.call();
  }

  async updateColetivoUrbano(
    concessaoColetivoUrbanoDTO: ConcessaoColetivoUrbanoDTO
  ): Promise<ConcessaoColetivoUrbanoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: "mob/concessao/coletivourbano/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({
            cdConcessao: concessaoColetivoUrbanoDTO.cdConcessao,
          }),
        }),
        data: new JSONData(concessaoColetivoUrbanoDTO),
      }),
      new HttpResponse(new ConcessaoColetivoUrbanoDTO())
    );
    return await quark.call();
  }

  //Coletivo Rural
  async findColetivoRural(
    filtros?: IFilter
  ): Promise<Array<ConcessaoColetivoRuralDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/coletivorural",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<ConcessaoColetivoRuralDTO>())
    );
    return await quark.call();
  }

  async getColetivoRural(
    cdConcessao: number
  ): Promise<ConcessaoColetivoRuralDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/coletivorural/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new ConcessaoColetivoRuralDTO())
    );
    return await quark.call();
  }

  async createColetivoRural(
    concessaoColetivoRuralDTO: ConcessaoColetivoRuralDTO
  ): Promise<ConcessaoColetivoRuralDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: "mob/concessao/coletivorural",
          environment: environment,
        }),
        data: new JSONData(concessaoColetivoRuralDTO),
      }),
      new HttpResponse(new ConcessaoColetivoRuralDTO())
    );
    return await quark.call();
  }

  async updateColetivoRural(
    concessaoColetivoRuralDTO: ConcessaoColetivoRuralDTO
  ): Promise<ConcessaoColetivoRuralDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: "mob/concessao/coletivorural/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({
            cdConcessao: concessaoColetivoRuralDTO.concessao.cdConcessao,
          }),
        }),
        data: new JSONData(concessaoColetivoRuralDTO),
      }),
      new HttpResponse(new ConcessaoColetivoRuralDTO())
    );
    return await quark.call();
  }

  //Táxi
  async findTaxi(filtros?: IFilter): Promise<Array<ConcessaoTaxiDTO>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/taxi",
          environment: environment,
          filter: filtros,
        }),
      }),
      new HttpResponse(new Array<ConcessaoTaxiDTO>())
    );
    return await quark.call();
  }

  async getTaxi(cdConcessao: number): Promise<ConcessaoTaxiDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/taxi/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new ConcessaoTaxiDTO())
    );
    return await quark.call();
  }

  async createTaxi(
    permissaoTaxiDTO: PermissaoTaxiDTO
  ): Promise<PermissaoTaxiDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: "mob/permissaotaxi",
          environment: environmentv3,
        }),
        data: new JSONData(permissaoTaxiDTO),
      }),
      new HttpResponse(new PermissaoTaxiDTO())
    );
    return await quark.call();
  }

	//Mototaxi

	async getConcessionarioMototaxi(cdConcessionario: number): Promise<Concessao> {
		let quark = new Quark(
		  new HttpGet({
			url: new Url({
			  id: "mob/permissaomototaxi/concessao/:cdConcessionario",
			  environment: environmentv3,
			  pathParams: new JSONData({ cdConcessionario: cdConcessionario }),
			}),
		  }),
		  new HttpResponse(new Concessao())
		);
		return await quark.call();
  }

    //Motorista de Aplicativo
  
    async getConcessionarioMotoristaApp(cdConcessionario: number): Promise<Concessao> {
      let quark = new Quark(
        new HttpGet({
        url: new Url({
          id: "mob/permissaomotoristaapp/concessao/:cdConcessionario",
          environment: environmentv3,
          pathParams: new JSONData({ cdConcessionario: cdConcessionario }),
        }),
        }),
        new HttpResponse(new Concessao())
      );
      return await quark.call();
  }

    
		//Geral
	async getAuxiliares(cdConcessao:number):Promise<ConcessionarioPessoaDTO[]>{
    let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/concessao/:cdConcessao/auxiliares',
					environment: environment,
					pathParams: new JSONData({cdConcessao: cdConcessao})
				}),
			}),
			new HttpResponse(
				new Array<ConcessionarioPessoaDTO>()
			));
    return await quark.call();
	}

  async updateTaxi(
    permissaoTaxiDTO: PermissaoTaxiDTO
  ): Promise<PermissaoTaxiDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: "mob/permissaotaxi/:cdConcessao",
          environment: environmentv3,
          pathParams: new JSONData({
            cdConcessao: permissaoTaxiDTO.cdConcessao,
          }),
        }),
        data: new JSONData(permissaoTaxiDTO),
      }),
      new HttpResponse(new PermissaoTaxiDTO())
    );
    return await quark.call();
  }

  async getRepresentantes(
    cdConcessao: number
  ): Promise<ConcessionarioPessoaDTO[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/:cdConcessao/representantes",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new Array<ConcessionarioPessoaDTO>())
    );
    return await quark.call();
  }

  async getAllVeiculos(cdConcessao: number): Promise<ConcessaoVeiculoDTO[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/:cdConcessao/veiculos",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new Array<ConcessaoVeiculoDTO>())
    );
    return await quark.call();
  }

  async getLinhas(cdConcessao: number): Promise<Linha[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/:cdConcessao/linhas",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new Array<Linha>())
    );
    return await quark.call();
  }

  async getVistorias(cdConcessao: number): Promise<Vistoria[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/:cdConcessao/vistorias",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new Array<Vistoria>())
    );
    return await quark.call();
  }

  async getConcessao(cdConcessao: number): Promise<Concessao> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/concessao/:cdConcessao",
          environment: environment,
          pathParams: new JSONData({ cdConcessao: cdConcessao }),
        }),
      }),
      new HttpResponse(new Concessao())
    );
    return await quark.call();
  }

  async getConcessaoEscolar(cdConcessionario: number): Promise<Concessao> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/coletivoescolar/concessao/:cdConcessionario",
          environment: environmentv3,
          pathParams: new JSONData({ cdConcessionario: cdConcessionario }),
        }),
      }),
      new HttpResponse(new Concessao())
    );
    return await quark.call();
  }

  async getRelatorioQuantitativo(usuario: string): Promise<Blob> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/relatorioconcessoes/quantitativo?usuario=" + usuario,
          environment: environment,
        }),
        responseType: "Blob",
      }),
      new HttpResponse(new Blob())
    );
    return await quark.call();
  }

  async getRelatorioConcessao(filtros?: IFilter): Promise<Blob> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/relatorioconcessoes/concessao",
          environment: environment,
          filter: filtros,
        }),
        responseType: "Blob",
      }),
      new HttpResponse(new Blob())
    );
    return await quark.call();
  }

  async getRelatorioPermissao(filtros?: IFilter): Promise<Blob> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: "mob/relatoriospermissaotaxi/permissao",
          environment: environmentv3,
          filter: filtros,
        }),
        responseType: "Blob",
      }),
      new HttpResponse(new Blob())
    );
    return await quark.call();
  }

  async saveImgPermissionario(cdConcessao: number, formData: FormData): Promise<Array<string>> {
    let quark = new Quark (
        new HttpPost ({
            url: new Url ({
                id: 'mob/concessao/:cdConcessao/imagem',
                pathParams: new JSONData ({cdConcessao: cdConcessao}),
                environment: environment
            }),
            data: new FormFile(formData)
        }),
        new HttpResponse(new Array<string>())
    )
    return await quark.call();
  }
}
